import { createClient, type SupabaseClient } from '@supabase/supabase-js';

let client: SupabaseClient | null = null;

export const initSupabase = (url: string, anonKey: string): SupabaseClient => {
  client = createClient(url, anonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    }
  });
  return client;
};

export const initSupabaseFromEnv = (): SupabaseClient | null => {
  const url = import.meta.env.VITE_SUPABASE_URL;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
  if (!url || !anonKey) {
    // Greenfield setup: env not provisioned yet; stay null so dev can still boot.
    if (typeof console !== 'undefined') {
      console.warn(
        '[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY missing — running without backend.'
      );
    }
    return null;
  }
  return initSupabase(url, anonKey);
};

export const getSupabase = (): SupabaseClient => {
  if (!client) {
    throw new Error(
      'Supabase client not initialised. Configure VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY in .env.local.'
    );
  }
  return client;
};

export const hasSupabase = (): boolean => client !== null;
